import { render, staticRenderFns } from "./StudentAttendanceScans.vue?vue&type=template&id=83ba5796&"
import script from "./StudentAttendanceScans.vue?vue&type=script&lang=js&"
export * from "./StudentAttendanceScans.vue?vue&type=script&lang=js&"
import style0 from "./StudentAttendanceScans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports